import React from "react";

/**
 * Skeleton loader for the accounts page (?page=account).
 * Mirrors the profile-page layout: mobile shows the top tab bar, avatar,
 * greeting and details card; desktop shows the left sidebar + details card.
 */
const AccountsSkeleton: React.FC = () => {
  const detailRows = (
    <>
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          className={`flex items-center justify-between px-4 py-4 ${i < 3 ? "border-b border-gray-100" : ""}`}>
          <div className="skeleton-loader h-4 w-24 rounded" />
          <div className="skeleton-loader h-4 w-36 rounded" />
        </div>
      ))}
    </>
  );

  return (
    <div className="min-h-screen w-full touch-none bg-white">
      {/* ── Mobile (<768px) ─────────────────────────────────────────────── */}
      <div className="flex flex-col md:hidden">
        {/* Top tab bar: Profile | Orders */}
        <div className="flex h-[52px] w-full items-center border-b border-gray-100">
          <div className="flex h-full flex-1 items-center justify-center space-x-2">
            <div className="skeleton-loader h-5 w-5 rounded-full" />
            <div className="skeleton-loader h-4 w-16 rounded" />
          </div>
          <div className="flex h-full flex-1 items-center justify-center space-x-2 border-l border-gray-100">
            <div className="skeleton-loader h-5 w-5 rounded-full" />
            <div className="skeleton-loader h-4 w-16 rounded" />
          </div>
        </div>

        <div className="flex flex-col px-4 pt-4">
          {/* "Profile" heading */}
          <div className="flex items-center space-x-2">
            <div className="skeleton-loader h-6 w-6 rounded" />
            <div className="skeleton-loader h-5 w-20 rounded" />
          </div>

          {/* Avatar + greeting */}
          <div className="flex flex-col items-center pt-6">
            <div className="skeleton-loader h-20 w-20 rounded-full" />
            <div className="skeleton-loader mt-4 h-4 w-28 rounded" />
          </div>

          {/* Details card */}
          <div className="mt-6 flex flex-col rounded-xl border border-gray-100 bg-white">{detailRows}</div>

          {/* Edit profile button */}
          <div className="skeleton-loader mt-6 h-[64px] w-full rounded-xl" />
        </div>
      </div>

      {/* ── Desktop (≥768px) ────────────────────────────────────────────── */}
      <div className="hidden min-h-screen w-full px-10 py-12 md:flex">
        {/* Left sidebar */}
        <div className="flex h-[600px] w-[312px] shrink-0 flex-col rounded-[10px] bg-gray-50">
          <div className="flex flex-col items-center border-b border-gray-200 px-6 pt-8">
            <div className="flex h-[176px] w-full items-center justify-center">
              <div className="skeleton-loader h-[82px] w-[82px] rounded-full" />
            </div>
            <div className="skeleton-loader mb-6 mt-3 h-5 w-32 rounded" />
          </div>
          <div className="flex flex-col space-y-3 px-4 py-5">
            <div className="skeleton-loader h-9 w-full rounded-lg" />
            <div className="skeleton-loader h-9 w-full rounded-lg" />
          </div>
        </div>

        {/* Right: details card */}
        <div className="flex flex-1 justify-center pt-12">
          <div className="flex h-fit w-[540px] flex-col rounded-xl bg-white p-4 shadow-[0px_0px_0px_1px_rgba(10,13,18,0.05),0px_1px_2px_0px_rgba(10,13,18,0.05)]">
            <div className="skeleton-loader mx-4 mb-2 h-5 w-20 rounded" />
            {detailRows}
            <div className="skeleton-loader mt-8 h-[64px] w-full rounded-xl" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountsSkeleton;
